import { render, staticRenderFns } from "./AiAgentMoreDropdown.vue?vue&type=template&id=42bed741"
import script from "./AiAgentMoreDropdown.vue?vue&type=script&lang=js"
export * from "./AiAgentMoreDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports